export default {"src":"/_next/static/media/swap.a97d0726.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};